let pending: Promise<void> | null = null;

/** The vendor bootstrap creates its own command queue, so boot/show can follow onload. */
export function loadMessenger(appId: string): Promise<void> {
  if (pending !== null) return pending;

  pending = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${encodeURIComponent(appId)}`;

    function fail(): void {
      clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      script.remove();
      pending = null;
      reject(new Error('Support messenger script did not load'));
    }

    const timeout = setTimeout(fail, 20_000);
    script.onerror = fail;
    script.onload = (): void => {
      clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      resolve();
    };
    document.head.appendChild(script);
  });
  return pending;
}
